<template>
    <span class="d-flex align-center ga-2">
        <v-icon v-if="icon" :icon="icon" :color="color" class="cursor-pointer"/>
        <span>{{ status }}</span>
    </span>
</template>

<script setup>
    import { onBeforeMount, ref } from 'vue';
    import { mdiHelp, mdiCheck, mdiAlertOutline, mdiAlertCircleOutline } from '@mdi/js';

    const props = defineProps(['params']);

    const icons = {
        mdiHelp,
        mdiCheck,
        mdiAlertCircleOutline,
        mdiAlertOutline
    };
    const icon = ref('');
    const status = ref('');
    const color = ref('');

    onBeforeMount(() => {
        if (typeof props.params.value != 'undefined' && props.params.node.rowPinned != 'bottom') {
            if (!Number.isNaN(parseInt(props.params.value))) {
                switch (parseInt(props.params.value)) {
                    case -1:
                        status.value = 'Unknown';
                        icon.value = icons.mdiHelp;
                        break;

                    case 0:
                        status.value = 'Success';
                        icon.value = icons.mdiCheck;
                        color.value = 'success';
                        break;

                    case 1:
                        status.value = 'DoneWithError';
                        icon.value = icons.mdiAlertOutline;
                        color.value = 'warning';
                        break;

                    case 2:
                        status.value = 'StopWithFatalError';
                        icon.value = icons.mdiAlertCircleOutline;
                        color.value = 'error';
                        break;

                    case 10:
                        status.value = 'UnknownError';
                        icon.value = icons.mdiHelp;
                        color.value = 'info';
                        break;
                }
            }

            else
                status.value = props.params.value;
        }
    });

</script>
